import {ADD_IMAGE_STORE, REMOVE_IMAGE, MODIFY_IMAGE_SOURCE, MODIFY_IMAGE_DESC, CARREGAR_IMAGES_STORE, DELETE_IMAGE_STORE} from '../constants/constants'
import {List, Map} from 'immutable';

function outterImagens(state, action){
    switch(action.type){
        case CARREGAR_IMAGES_STORE:
            return List(action.imagens.map(obj=>Map(obj)).reverse())
    }
    return state
}

export default (imagensStateOld = List([]), action) =>{ 

    const imagensState = outterImagens(imagensStateOld, action);

    let {img, desc, id, name} = action;

    switch(action.type){

        case DELETE_IMAGE_STORE:
            return imagensState.filter(function(k,v){
                return k.get('id') != id;
            })

        case MODIFY_IMAGE_SOURCE:
            return imagensState.map(obj=>{
                if (obj.id == id){
                    obj.img = img;
                }
                return obj;                       
            });

        case MODIFY_IMAGE_DESC:
            return imagensState.map(obj=>{
                if (obj.get('id')== id){
                    return obj.set('desc', desc);
                }
                return obj;                       
            });

        case REMOVE_IMAGE:
            return imagensState.map(obj=>{
                if (obj.id == id){
                    obj.img = "";
                }
                return obj;                       
            });

            
    }
    return imagensState;
};


// WEBPACK FOOTER //
// ./src/reducers/images.js